import { render, staticRenderFns } from "./WhitelistedAccount.vue?vue&type=template&id=596a0747&"
import script from "./WhitelistedAccount.vue?vue&type=script&lang=js&"
export * from "./WhitelistedAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports